import { render } from "./LaputaHero.vue?vue&type=template&id=fb8e8f5c&scoped=true"
const script = {}

import "./LaputaHero.vue?vue&type=style&index=0&id=fb8e8f5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb8e8f5c"]])

export default __exports__